import { useSearchParams } from 'next/navigation'
import { useHttpClient } from './useHttpClient'

export const useDebugLogging = () => {
  const httpClient = useHttpClient()
  const searchParams = useSearchParams()
  const logError = (error: string) => {
    if (searchParams?.get('debug') !== 'true') {
      return
    }

    try {
      httpClient('logging/error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: error, url: window.location.href }),
      })
    } catch {
      // ignore
    }
  }

  return { logError }
}

export const useErrorLogging = () => {
  const httpClient = useHttpClient()
  const logError = (error: string) => {
    try {
      httpClient('logging/error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: error, url: window.location.href }),
      })
    } catch {
      // ignore
    }
  }

  return { logError }
}
